import type { EcommerceProduct } from './types'

export interface ProductListRenderOptions {
  list: string
  location: string
  group: string
  label?: string
  category?: string
  products: EcommerceProduct[]
  positionOffset?: number
  locale: Locales
}

const MAX_PRODUCTS = 200

export const trackProductListRender = ({
  list,
  location,
  group,
  label,
  category,
  products,
  positionOffset = 0,
  locale,
}: ProductListRenderOptions) => {
  if (!products.length) return

  pushEventToDataLayer(
    'custom.product.list.render',
    {
      group,
      label,
      category,
      info: { location, count: products.length },
      product: { list },
      ecommerceType: 'product-list-render',
      // GA4 reads `impressions`; this event is consumed separately.
      ecommerce: {
        currencyCode: localeConfig[locale]?.currency,
        products: products.slice(0, MAX_PRODUCTS).map((product, index) => ({
          ...product,
          list,
          position: positionOffset + index + 1,
        })),
      },
    },
    locale,
  )
}
